import './css/pill.css';

interface IPillProps {
  label: string;
  value: number;
  handleClick?: () => void;
  isSelected?: boolean;
  isDisabled?: boolean;
  className?: string;
}

export const Pill = ({ label, value, handleClick, isSelected, isDisabled, className = '' }: IPillProps) => {
  return (
    <label
      key={value}
      className={`checkbox-pill${isDisabled ? ' month-disabled' : ''}${isSelected ? ' month-selected' : ''} ${className}`}
    >
      <input type="checkbox" value={value} checked={isSelected} onChange={handleClick} hidden />
      {label}
    </label>
  );
};
